import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getLeagueByID } from "../../services/leaguesAPI";
import { Modal } from "../../components/modals/Modal";
import { CreateLeague } from "../../components/admin/CreateLeague";
import Loader from "../../components/ui/loader";
import { useAuthStore } from "../../store/authStore";

export const League = () => {
  const [isLoading, setLoading] = useState(true);
  const { leagueID } = useParams();
  const [league, setLeague] = useState(null);
  const [isOpenModal, setOpenModal] = useState(false);
  const { user } = useAuthStore();

  const fetchLeague = async () => {
    setLoading(true);
    try {
      let response = await getLeagueByID(leagueID);
      console.log(response);
      if (response.success) {
        setLeague(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    fetchLeague();
  }, [leagueID]); //eslint-disable-line

  if (isLoading) {
    return (
      <div className="min-h-screen bg-flyers-black flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-flyers-black text-white">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-wrap justify-end mt-6 gap-3">
          <Link
            to={`/fights?league=${league?.name}`}
            className="px-4 py-2 bg-flyers-orange text-white font-heading font-bold uppercase tracking-wider rounded hover:bg-flyers-orange-light transition-colors duration-150 text-sm"
          >
            View Fights
          </Link>
          <Link
            to={`/games?league=${league?.name}`}
            className="px-4 py-2 bg-flyers-orange text-white font-heading font-bold uppercase tracking-wider rounded hover:bg-flyers-orange-light transition-colors duration-150 text-sm"
          >
            View Games
          </Link>
          {user?.role === "admin" && (
            <button
              className="px-4 py-2 bg-flyers-orange text-white font-heading font-bold uppercase tracking-wider rounded hover:bg-flyers-orange-light transition-colors duration-150 text-sm"
              onClick={() => setOpenModal(true)}
            >
              Update League
            </button>
          )}
        </div>

        {league && (
          <div className="flex flex-col items-center mt-10">
            {league.leagueImageFile && (
              <img
                src={league.leagueImageFile}
                alt="League logo"
                className="mt-5 w-32 h-32 sm:w-40 sm:h-40 object-contain"
              />
            )}
            <h1 className="font-heading text-3xl sm:text-4xl font-black uppercase tracking-wide text-flyers-orange mt-4">
              {league.name}
            </h1>
            <h2 className="text-xl mt-3 text-flyers-light-gray text-center">{league.description}</h2>
          </div>
        )}

        {league?.Teams ? (
          <div className="mt-12">
            <h1 className="font-heading text-2xl font-bold uppercase tracking-wider text-flyers-orange text-center mb-6">
              Teams
            </h1>
            <div className="flex flex-wrap gap-3 justify-center max-h-[40vh] overflow-auto">
              {league?.Teams?.map((team) => (
                <Link
                  to={`/team/${team?.TeamID}`}
                  className="border border-flyers-dark-gray bg-flyers-charcoal hover:border-flyers-orange px-4 py-3 rounded transition-colors duration-150 text-flyers-light-gray hover:text-white"
                  key={team?.TeamID}
                >
                  {team?.city} {team?.name}
                </Link>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-3 my-5 justify-center">
            <h1 className="text-flyers-mid-gray">No Teams in this league</h1>
          </div>
        )}

        {isOpenModal && (
          <Modal isOpen={isOpenModal} close={handleCloseModal}>
            <CreateLeague
              id={leagueID}
              league={league}
              handleClose={handleCloseModal}
              fetchLeague={fetchLeague}
            />
          </Modal>
        )}
      </div>
    </div>
  );
};
